

<div style="width: 99%" [@shellRoutes]="animationState">
  <router-outlet (activate)="onActivate()"></router-outlet>
</div>
